import { useLang } from "../i18n/LangContext";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFloat() {
    const { t } = useLang();
    const info = t.contact?.info;
    if (!info?.whatsappLink) return null;
    return (
        <a
            href={info.whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-float"
            aria-label={info.whatsappCta}
            className="fixed bottom-6 left-6 z-50 group flex items-center gap-3 bg-mint text-ink hover:bg-mint-hover transition-all shadow-lg hover:shadow-2xl px-5 py-4 border-2 border-ink font-display uppercase tracking-widest text-xs"
        >
            <MessageCircle size={22} strokeWidth={2} className="flex-shrink-0" />
            <span className="hidden sm:inline whitespace-nowrap">
                {info.whatsappCta}
            </span>
        </a>
    );
}
